import OrganizationForm from 'src/components/dashboard_organizations/organization_form';
import { FilesProvider } from 'src/context/files.jsx';
import { OrganizationsProvider } from 'src/context/organization';

const Page = () => (
	<FilesProvider>
		<OrganizationsProvider>
			<OrganizationForm />
		</OrganizationsProvider>
	</FilesProvider>
);

export default Page;
